import emitter from '@utils/emitter'

export default {
  name: 'loading',

  ui: {
    button: '[js-loading-button]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle () {
        this.startExperience()
      },
    },
  ],

  componentDidMount () {
    const IS_DEV = window.location.hash.includes('devmode')

    if (IS_DEV) {
      emitter.trigger('LOADING_HIDE')
      this.el.classList.toggle('is-hidden')
    }

    this.ui.button.addEventListener('touchdown', this.startExperience)
  },

  startExperience () {
    emitter.trigger('LOADING_HIDE')
    this.el.classList.toggle('is-hidden')
  },
}
